export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'films-tv',
    name: '影视剧集',
    description: '最新国产电影、电视剧深度解析与行业观察',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'news-info',
    name: '新闻资讯',
    description: '国内外时事热点、政策解读与深度报道',
    icon: 'ri-newspaper-line',
  },
  {
    slug: 'entertainment',
    name: '娱乐综艺',
    description: '综艺节目、明星动态、流行文化前沿',
    icon: 'ri-live-line',
  },
  {
    slug: 'tech-digital',
    name: '科技数码',
    description: '科技前沿、数码评测、互联网行业趋势',
    icon: 'ri-smartphone-line',
  },
  {
    slug: 'culture-art',
    name: '文化艺术',
    description: '传统文化传承、当代艺术、文学创作',
    icon: 'ri-palette-line',
  },
  {
    slug: 'business-finance',
    name: '商业财经',
    description: '经济趋势、企业动态、投资理财洞察',
    icon: 'ri-line-chart-line',
  },
];